import { useMutation } from '@tanstack/react-query'
import { globalAdminDashboard } from '../index'

const useGlobalAdminDashboard = () =>
  useMutation({
    mutationFn: globalAdminDashboard,
  })

export default useGlobalAdminDashboard
